<template>
  <img src="@/assets/img/Icons/photo-station-primary.svg" />
</template>

<script>
export default {};
</script>

<style></style>
